<template>
  <div class="app-container">
    <side-navi v-if="$route.name !== 'login'" :isNewInfo="isNewInfo" v-show="visibleSideNavi"></side-navi>
    <router-view/>
    <loading :message="loadingMessage" :visible="visibleLoading" :closable="cancelToken != null" @close="onCloseLoading"></loading>
  </div>
</template>

<script>
import SideNaviCmp from './components/side-navi.vue'
import LoadingCmp from './components/loading/loading.vue'
import CommonUtil from './utils/common'
import LoadingManager from './utils/loading'

export default {
  name: 'App',
  components: {
    'side-navi': SideNaviCmp,
    'loading': LoadingCmp
  },
  data () {
    return {
      visibleLoading: false,
      loadingMessage: '',
      defaultLoadingOptions: {
        body: true,
        fullscreen: true,
        lock: true,
        text: null,
        background: 'rgba(0,0,0,0)'
      },
      loadingCmp: null,
      cancelToken: null,
      isNewInfo: false,
      visibleSideNavi: true
    }
  },
  created () {
    this.$on('loading-show', this.onShowLoading)
    this.$on('loading-hide', this.onHideLoading)
    this.$on('update-notifications', this.onUpdateNotification)
    this.$on('change-location', this.onChangeLocation)
  },
  destroyed () {
    this.$off('loading-show', this.onShowLoading)
    this.$off('loading-hide', this.onHideLoading)
    this.$off('update-notifications', this.onUpdateNotification)
    this.$off('change-location', this.onChangeLocation)
  },
  methods: {
    onShowLoading (message, cancelToken = null) {
      if (CommonUtil.isEmpty(message)) {
        if (CommonUtil.isNull(this.loadingCmp)) {
          this.loadingCmp = this.$loading(this.defaultLoadingOptions)
        }
      } else {
        this.cancelToken = cancelToken
        this.loadingMessage = message
        this.visibleLoading = true
      }
    },
    onCloseLoading () {
      if (CommonUtil.isNotNull(this.cancelToken)) {
        this.cancelToken.cancel()
        LoadingManager.hide(this)
      }
    },
    onHideLoading () {
      this.cancelToken = null
      this.visibleLoading = false
      this.loadingMessage = ''
      if (CommonUtil.isNotNull(this.loadingCmp)) {
        this.loadingCmp.close()
        this.loadingCmp = null
      }
    },
    onUpdateNotification (notifications) {
      this.isNewInfo = notifications.isNewInfo
    },
    onChangeLocation (to) {
      const meta = this.$route.meta
      if (CommonUtil.isNotEmpty(meta.title)) {
        document.title = meta.title
      }
      this.visibleSideNavi = CommonUtil.isNotEmpty(meta.notification)
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  background-position: center center;
  box-sizing: border-box;
  outline: none;
}
html, body {
  min-height: 100vh;
}
body {
  display: flex;
  flex-direction: column;
  margin: 0;
  color: #394445;
  font-size: 16px;
  line-height: 2;
  word-wrap: break-word;
  background: linear-gradient(to bottom, #7bade7, #bde0eb) fixed;
}
body, input, textarea {
  font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", "Meiryo", sans-serif;
}

.app-container {
  display: flex;
  flex-direction: row;
  min-width: 1200px;
  min-height: 100vh;
}

.error-message {
  display: none;
}
.has-error .error-message {
  display: block;
  color: #d8243e;
  line-height: 1.3;
  margin-top: 4px;
  font-size: .8rem;
  font-weight: bold;
}

a:not(.disabled), .link:not(.disabled) {
  color: #2456d4;
  text-decoration: none;
  cursor: pointer;
}
a:not(.disabled):hover, .link:not(.disabled):hover {
  text-decoration: underline;
}

.delete-confirm-button {
  background-color: #d8243e;
  border: #d8243e;
}

</style>



// WEBPACK FOOTER //
// src/app.vue